(() => {
  if (customElements.get('mobile-slide-out')) {
    return;
  }

  class MobileSlideOut extends customElements.get('slide-out-drawer') {
    constructor() {
      super();
      this.mobileMatchQuery = window.matchMedia('(max-width: 989px)');
      this.selectors = {
        bundleCard: '[data-bundle-card]',
        opener: 'drawer-opener',
        wrapper: 'data-island.bundle-product',
      }
    }

    /**
     * Show.
     * 
     * @param {HTMLElement} opener 
     */
    show(opener) {
      super.show(opener);
      this.dispatchOpen();
    }

    /**
     * Handle resize.
     * 
     * @returns {Void}
     */
    handleResize() {
      // Check if viewport width is different
      if (window.innerWidth === this.lastViewportWidth) {
        return;
      }
      this.lastViewportWidth = window.innerWidth;
      if (this.mobileMatchQuery.matches) {
        this.hide();
        return;
      }
      this.dispatchOpen();
    }

    /**
     * Dispatch open.
     */
    dispatchOpen() {
      this.classList.add('has-been-opened');
      this.openers.forEach(opener => {
        opener.classList.add('has-been-opened');
      });
      this.dispatchEvent(new CustomEvent('mobile-slide-out:open', {
        bubbles: true
      }));

      this.updateSubscriptionText();
    }

    /**
     * Update subscription text.
     * 
     * @returns {Void}
     */
    updateSubscriptionText() {
      const subscriptionInput = this.querySelector('input:checked');
      if (!subscriptionInput) {
        return;
      }
      
      const selectedValue = subscriptionInput.value;
      this.openers.forEach(opener => {
        opener.querySelector('[data-select-option]')?.classList.add('hidden');
        opener.querySelector('[data-selected-one-time]')?.classList.toggle('hidden', selectedValue !== 'one-time');
        opener.querySelector('[data-selected-subscribe]')?.classList.toggle('hidden', selectedValue === 'one-time');
      });
    }

    /**
     * Hide.
     * 
     * @extends
     */
    hide(){ 
      super.hide();
      this.updateSubscriptionText();
    }
    
    /**
     * Handle quantity update.
     */
    handleQuantityUpdate() {
      const bundleCardsQuantity = [...this.bundleCards].reduce((acc, card) => {
        return acc + parseInt(card.querySelector('input[type="number"]').value);
      }
      , 0);

      this.openers.forEach(opener => {
        const selectOptionsHolder = opener.querySelector('[data-select-option]');
        const selectedOptionsHolder = opener.querySelector('[data-selected-options]')
  
        selectedOptionsHolder.textContent = bundleCardsQuantity > 0 
          ? `${bundleCardsQuantity} ${selectedOptionsHolder.dataset.text}`
          : `0 ${selectedOptionsHolder.dataset.text}`
        
        selectOptionsHolder.classList.toggle('hidden', bundleCardsQuantity > 0);
        selectedOptionsHolder.classList.toggle('hidden', bundleCardsQuantity === 0);
      })
    }

    /**
     * Connected callback.
     */
    connectedCallback() {
      this.addEventListener('bundle:quantity:update', this.handleQuantityUpdate.bind(this));
      this.lastViewportWidth = window.innerWidth;
      window.addEventListener('resize', this.handleResize.bind(this));
      this.bundleCards = this.querySelectorAll(this.selectors.bundleCard);
      this.wrapper = this.closest(this.selectors.wrapper);
      this.openers = this.wrapper.querySelectorAll(`${this.selectors.opener}[data-drawer="#${this.getAttribute('id')}"]`);
    }
  }

  customElements.define('mobile-slide-out', MobileSlideOut);
})();